import { useSessionStore } from './sessionStore';
export function useSession() {
    const usuario = useSessionStore((s) => s.usuario);
    const accessToken = useSessionStore((s) => s.accessToken);
    const hidratado = useSessionStore((s) => s.hidratado);
    const tieneRol = useSessionStore((s) => s.tieneRol);
    const tieneAlgunRol = useSessionStore((s) => s.tieneAlgunRol);
    return {
        usuario,
        autenticado: Boolean(accessToken && usuario),
        hidratado,
        tieneRol,
        tieneAlgunRol,
        esPromotor: usuario?.esPromotor ?? false,
        esPromotorExterno: usuario?.esPromotorExterno ?? false,
        promotorId: usuario?.promotorId ?? null,
        promotorNombre: usuario?.promotorNombre ?? null,
    };
}
